<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showDividirMulta"
      scrollable
      no-close-on-backdrop
      title="Detalle Multa"
      cancel-variant="outline-secondary"
      size="sm"
      @hidden="close"
    >
      <span> <b>Concepto:</b></span>
      <b-row class=" mb-1 ">
        <b-col md="12" class="text-justify">
          <div
            style="background:#f0f0f0; font-size:13px; border-radius:5px; padding:7px"
          >
            {{ multa.concepto }}
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col md="4"
          ><b-badge variant="success">
            Abono: {{ multa.valor_cancelado }} $
          </b-badge></b-col
        >
        <b-col md="4"
          ><b-badge variant="danger">
            Saldo: {{ multa.valor_pendiente }} $
          </b-badge></b-col
        >
        <b-col md="4"
          ><b-badge variant="info">
            Total: {{ multa.v_total }} $
          </b-badge></b-col
        >
      </b-row>
      <b-row>
        <b-col md="12">
          <div
            v-if="
              USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TESORERIA
            "
            class="form-label-group  mt-1"
          >
            <span style="font-weight: bold;font-size: 13px;"
              >¿ Deseas divir la multa en cuotas ?</span
            >
            <b-form-input
              placeholder="Ingrese #cuotas"
              size="sm"
              type="number"
              v-model="total1"
              :disabled="multa.conDetalle ? true : false"
            />
            <label for="floating-label1"> # Cuotas</label>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-list-group>
            <b-list-group-item
              v-for="(item, index) in multa.detalle"
              :key="index"
              class="no-hover"
              :variant="item.pagada == 's' ? 'success' : 'danger'"
            >
              <b-row>
                <b-col md="7">{{ item.concepto }} </b-col>
                <b-col md="3">{{ item.v_total }} $</b-col>
                <b-col md="2"
                  ><feather-icon
                    icon="FileTextIcon"
                    class="ml-1 cursor-pointer"
                    size="12"
                    @click="showDetalleRecibo(item)"
                  ></feather-icon
                ></b-col>
              </b-row>
              <!-- <span>{{ item.concepto }}</span>
              <span style="float:right">{{ item.v_total }} $</span>
              <br /> -->
              <span
                style="font-size:10px; color:gray"
                v-if="item.fecha != '0000-00-00'"
                >{{ item.fecha }} {{ item.observacion }}</span
              >
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="12">
          <div
            v-if="
              USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TESORERIA
            "
            class="form-label-group  mt-1"
          >
            <span style="font-weight: bold;font-size: 13px;"
              >¿ Deseas realizar un abono?</span
            >
            <b-form-input
              placeholder="Ingrese el valor que desea pagar"
              size="sm"
              type="number"
              v-model="valorPagar"
              @keyup="handleChange"
              v-if="multa.valor_pendiente != 0"
            />
            <label for="floating-label1"> Deseo pagar el valor de:</label>
          </div>
        </b-col>
        <b-col md="12" class="mt-1">
          <div
            v-if="valorPagar != '' && valorPagar != null"
            class="form-label-group"
          >
            <b-form-input
              id="floating-nacimiento"
              type="date"
              size="sm"
              v-model="fechaPago"
            />
            <label for="floating-nacimiento">Fecha de pago</label>
          </div>
        </b-col>
        <b-col md="12" class="mt-1">
          <div
            v-if="valorPagar != '' && valorPagar != null"
            class="form-label-group"
          >
            <b-form-textarea
              id="textarea-auto-height"
              placeholder="Observación(Opcional): Ejemplo pagado en la sesión presencial del martes"
              rows="2"
              size="sm"
              max-rows="3"
              v-model="detalle"
            />
            <label for="floating-auto-height">Observacion (Opcional)</label>
          </div>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <b-button
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA
              "
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              @click="saveDetalle"
            >
              Guardar
            </b-button>
            <div v-if="showLoading" class="text-center mt-1">
              <b-spinner variant="primary" label="Text Centered" />
            </div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="float-right mr-1"
              @click="close"
            >
              Cancelar
            </b-button>
          </template>
          <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px; z-index:1000"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BFormInput,
  BRow,
  BCol,
  BModal,
  BListGroup,
  BListGroupItem,
  BBadge,
  BButton,
  BAlert,
  BSpinner,
  BFormTextarea,
  // BFormCheckbox,
  //   BListGroup,
  //   BIconLayers,
} from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { heightFade } from '@core/directives/animations'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   TARJETAS,
  USER,
  ROLES,
  // xxx,
} from '../../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BModal,
    BListGroup,
    BListGroupItem,
    BBadge,
    BButton,
    BAlert,
    BSpinner,
    BFormTextarea,
    // BFormCheckbox,
  },
  directives: {
    Ripple,
    heightFade,
  },
  props: {
    multa: Object,
    // total: Number,
  },
  setup(props, { emit }) {
    // const total = ref(0)
    const showLoading = ref(false)
    const variante = ref('danger')
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    const hasError = ref(false)
    const valorPagar = ref(null)
    const fechaPago = ref(null)
    const detalle = ref(null)
    const { postApi } = apiCall()

    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function handleChange() {
      // console.log('Nuevo valor:', valorPagar.value)
      if (valorPagar.value === '') {
        detalle.value = null
        fechaPago.value = null
      }
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    // const total = computed(() => props.multa.detalle.length)
    // const total1 = computed({
    //   get() {
    //     return props.total
    //     // your getter
    //   },
    //   set(val) {
    //     console.log(val)
    //     props.total = val
    //     // your setter
    //   },
    // })
    // const total = ref(props.multa.detalle.length)
    function calcularSubtotal(numeroCuotas, vTotal) {
      return vTotal / numeroCuotas
    }
    function showDetalleRecibo(item) {
      // console.log('detalle')
      emit('showRecibo', item)
    }
    function crearLista(size) {
      props.multa.detalle = []
      if (size !== null && size !== 0 && size !== '') {
        // console.log(size)
        if (size >= 2) {
          const valor = calcularSubtotal(size, props.multa.v_total)
          for (let index = 0; index < size; index += 1) {
            const obj = {
              concepto: `${index + 1} Abono`,
              v_unitario: valor.toFixed(2),
              v_total: valor.toFixed(2),
            }
            props.multa.detalle.push(obj)
          }
        } else {
          showMessageAlert('danger', '# cuotas debe ser mayor o igual a dos')
        }
      } else {
        props.multa.detalle = []
      }
    }
    const total1 = computed({
      get: () => {
        let ret = null
        if (props.multa.detalle.length > 0) {
          ret = props.multa.detalle.length
        }
        return ret
      },
      set: value => {
        crearLista(value)
        // props.multa.detalle.length = value
      },
    })
    function hasErrorPagada() {
      let valido = false
      // console.log(Number(props.multa.valor_pendiente))
      if (valorPagar.value !== 0) {
        if (Number(valorPagar.value) > Number(props.multa.valor_pendiente)) {
          showMessageAlert(
            'danger',
            // eslint-disable-next-line
            'El valor no debe ser mayor al saldo pendiente '
          )
        } else if (fechaPago.value === null || fechaPago.value === '') {
          showMessageAlert('danger', 'Fecha no debe ser vacia')
        } else {
          valido = true
        }
      }
      return valido
    }
    async function saveDetalle() {
      const path = 'ApiMultas/insertDivideMulta'
      showLoading.value = true
      const data = {
        id_multa: props.multa.id_multa,
        multas: props.multa.detalle,
        valor_pagar: valorPagar.value,
        fecha_pago: fechaPago.value,
        observacion: detalle.value,
        saldo: props.multa.valor_pendiente,
      }
      let isValid = true
      if (valorPagar.value > 0) {
        isValid = hasErrorPagada()
      }

      // console.log(isValid)
      if (isValid) {
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          emit('recargaMultas')
        } else {
          showMessageAlert('danger', response.mensaje)
        }
      }
      showLoading.value = false

      //   cardItem.value.showLoading = false
    }

    function close() {
      props.multa.detalle = []
      valorPagar.value = null
      fechaPago.value = null
      detalle.value = null
      countDownChanged(0)
      store.commit('someVariables/UPDATE_SHOW_DIVIDIR_MULTA', false)
    }
    return {
      //   total,
      //   crearLista,
      close,
      total1,
      showLoading,
      countDownChanged,
      dismissCountDown,
      saveDetalle,
      variante,
      messageError,
      USER,
      ROLES,
      valorPagar,
      fechaPago,
      handleChange,
      detalle,
      showDetalleRecibo,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.no-hover:hover {
  background-color: inherit !important;
  cursor: default !important;
}
</style>
